import React__default from 'react';
import classNames from 'classnames';
import Styles from './EllipsisTooltip.module.scss.js';

const EllipsisTooltip = ({ textValue = "", greaterThanValue, styles, mainClass, defaultValueClassName, toolTipClassName }) => {
    return (React__default.createElement("span", { className: classNames(mainClass, textValue.length > greaterThanValue ? Styles.ellipsisTooltip : Styles.noTooltip), style: styles },
        React__default.createElement("span", { className: classNames(Styles.defaultValue, defaultValueClassName) }, textValue),
        React__default.createElement("span", { className: classNames(Styles.tooltip, toolTipClassName) }, textValue)));
};

export { EllipsisTooltip as default };
//# sourceMappingURL=EllipsisTooltip.js.map
